import {
  Box,
  Button,
  Card,
  Divider,
  Typography,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const MobileUIBlocker = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [overlay, setOverlay] = useState<boolean>(true);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileDevice =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(
        userAgent
      );

    setIsMobile(isMobileDevice);
  }, []);

  if (!isMobile || !overlay) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: ' 100%',
        height: '100%',
        background: theme.colors.alpha.black[30],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        textAlign: 'center'
      }}
    >
      <Card sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4" p={2}>
          {t('Optimal Experience Notice')}
        </Typography>
        <Divider />
        <Typography variant="h5" my={2} p={2}>
          {t('For the best experience, please use a desktop device.')}
        </Typography>
        <Divider />
        <Box p={2} display="flex" justifyContent="flex-end">
          <Button variant="contained" onClick={() => setOverlay(false)}>
            {t('Got it')}
          </Button>
        </Box>
      </Card>
    </Box>
  );
};
